/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Find and replace runs entirely in your browser; your text is never uploaded.`)
};

const es_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Buscar y reemplazar se ejecuta completamente en tu navegador; tu texto nunca se carga.`)
};

const de_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Suchen und Ersetzen läuft vollständig in Ihrem Browser; Ihr Text wird niemals hochgeladen.`)
};

const nl_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Zoeken en vervangen wordt volledig in uw browser uitgevoerd; uw tekst wordt nooit geüpload.`)
};

const fr_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Chercher et remplacer fonctionne entièrement dans votre navigateur ; votre texte n'est jamais téléchargé.`)
};

const it_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Cerca e sostituisci viene eseguito interamente nel tuo browser; il tuo testo non viene mai caricato.`)
};

const pt_br2_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Localizar e substituir funciona totalmente em seu navegador; seu texto nunca é carregado.`)
};

const pt_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Procurar e substituir executa inteiramente no seu navegador; o seu texto nunca é enviado.`)
};

const ja_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。検索と置換はブラウザ内で完全に実行され、テキストはアップロードされません。`)
};

const zh_fr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。查找和替换完全在你的浏览器中运行；你的文本永远不会被上传。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq3_a", locale)
	if (locale === "en") return en_fr_faq3_a(inputs)
	if (locale === "es") return es_fr_faq3_a(inputs)
	if (locale === "de") return de_fr_faq3_a(inputs)
	if (locale === "nl") return nl_fr_faq3_a(inputs)
	if (locale === "fr") return fr_fr_faq3_a(inputs)
	if (locale === "it") return it_fr_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq3_a(inputs)
	if (locale === "pt") return pt_fr_faq3_a(inputs)
	if (locale === "ja") return ja_fr_faq3_a(inputs)
	return zh_fr_faq3_a(inputs)
};